// @flow
import {
  pageId,
  productName,
  brand,
  category,
  rating,
  reviewIncludesResponse,
  questionIncludesAnswer,
  questionHasVisualAnswers,
  isUpdatedReview,
  native,
  locale,
  merchantUserId,
  variantId,
  // questionType,
  //answerType,
  // answerStatus,
  createUgcId,
  codesIncluded,
  codesExcluded,
  siteStatus,
  // statusIncluded,
  // statusExcluded,
  catalog,
  merchantUserEmail,
  commentsKeyword,
  // questionKeyword,
  //contentDisclosureCodes,
  deviceId,
  setReadonlyUgcType,
  mediaUgcType,
  reviewHeadline,
  author,
  pwrDistroMediaUgcType,
} from './fields.config';
import type { FieldsetConfig } from '../FieldConfig';
import ProductTagIcon from 'components/Icons/ProductTag';
import StarsIcon from 'components/Icons/FiveStarsEmpty';
import MediaIcon from 'components/Icons/MediaPlaceholder';
import {
  Question as QuestionIcon,
  Answer as AnswerIcon,
} from 'components/Icons/QA';

type FormOptions = {
  primaryFieldsets: Array<FieldsetConfig>,
  extraFieldsets?: Array<FieldsetConfig>,
};

export const ProductOptionsFieldset = {
  legend: 'Product Options',
  Icon: ProductTagIcon,
  fields: [pageId, productName, brand, category],
};

export const ReviewFieldsets: FormOptions = {
  primaryFieldsets: [
    ProductOptionsFieldset,
    {
      legend: 'Review Options',
      Icon: StarsIcon,
      fields: [
        setReadonlyUgcType('Review'),
        createUgcId('Review'),
        rating,
        // reviewerType,
        // statusIncluded,
        // statusExcluded,
        codesIncluded,
        codesExcluded,
        reviewIncludesResponse,
        isUpdatedReview,
        siteStatus,
      ],
    },
  ],

  extraFieldsets: [
    {
      fields: [
        // merchants,
        author,
        reviewHeadline,
        catalog,
        merchantUserEmail,
        commentsKeyword,
        // contentDisclosureCodes,
        deviceId,
      ],
    },
  ],
};

export const pwrDistroReviewFieldsets: FormOptions = {
  primaryFieldsets: [
    {
      legend: 'Product Options',
      Icon: ProductTagIcon,
      fields: [pageId, variantId, productName, brand, category],
    },
  ],

  extraFieldsets: [
    {
      legend: 'Review Options',
      Icon: StarsIcon,
      fields: [
        createUgcId('Review'),
        setReadonlyUgcType('Review'),
        rating,
        author,
        reviewHeadline,
        commentsKeyword,
        isUpdatedReview,
        siteStatus,
        locale,
        merchantUserEmail,
        merchantUserId,
        native,
        deviceId,
        codesIncluded,
        codesExcluded,
        reviewIncludesResponse,
      ],
    },
  ],
};

export const PwrDistroMediaFieldsets: FormOptions = {
  primaryFieldsets: [
    {
      legend: 'Product Options',
      Icon: ProductTagIcon,
      fields: [pageId, variantId, productName, brand, category],
    },
  ],
  extraFieldsets: [
    {
      legend: 'Media Options',
      Icon: MediaIcon,
      fields: [
        createUgcId('Media'),
        pwrDistroMediaUgcType,
        author,
        reviewHeadline,
        siteStatus,
        locale,
        merchantUserEmail,
        merchantUserId,
        deviceId,
        codesIncluded,
        codesExcluded,
      ],
    },
  ],
};

export const PwrDistroQuestionFieldsets: FormOptions = {
  primaryFieldsets: [
    {
      legend: 'Product Options',
      Icon: ProductTagIcon,
      fields: [pageId, variantId, productName, brand, category],
    },
  ],
  extraFieldsets: [
    {
      legend: 'Question Options',
      Icon: QuestionIcon,
      fields: [
        createUgcId('Question'),
        setReadonlyUgcType('Question'),
        siteStatus,
        locale,
        merchantUserEmail,
        merchantUserId,
        native,
        questionIncludesAnswer,
        questionHasVisualAnswers,
        deviceId,
        codesIncluded,
        codesExcluded,
      ],
    },
  ],
};

export const PwrDistroAnswerFieldsets: FormOptions = {
  primaryFieldsets: [
    {
      legend: 'Product Options',
      Icon: ProductTagIcon,
      fields: [pageId, variantId, productName, brand, category],
    },
  ],
  extraFieldsets: [
    {
      legend: 'Answer Options',
      Icon: AnswerIcon,
      fields: [
        createUgcId('Answer'),
        setReadonlyUgcType('Answer'),
        siteStatus,
        locale,
        merchantUserEmail,
        merchantUserId,
        native,
        deviceId,
        codesIncluded,
        codesExcluded,
      ],
    },
  ],
};

export const NetworkReviewFieldsets: FormOptions = {
  primaryFieldsets: [
    {
      ...ProductOptionsFieldset,
      fields: [
        {
          name: 'page_id',
          label: 'Page ID',
          type: 'text',
          style: { flexBasis: '100%' },
          attributes: { required: true },
        },
      ],
    },
    {
      legend: 'Review Options',
      Icon: StarsIcon,
      fields: [
        setReadonlyUgcType('Review'),
        createUgcId('Review'),
        rating,
        // reviewerType,
        codesIncluded,
        codesExcluded,
        author,
        reviewHeadline,
        siteStatus,
        // contentDisclosureCodes,
      ],
    },
  ],
};

export const MediaFieldsets: FormOptions = {
  primaryFieldsets: [
    ProductOptionsFieldset,
    {
      legend: 'Media Options',
      Icon: MediaIcon,
      fields: [
        // reviewerType,
        createUgcId('Media'),
        mediaUgcType,
        // statusIncluded,
        // statusExcluded,
        codesIncluded,
        codesExcluded,
        siteStatus,
        catalog,
      ],
    },
  ],
  // extraFieldsets: [
  //   {
  //     fields: [
  //       // merchants,
  //       // merchantUserEmail,
  //       // commentsKeyword,
  //       //contentDisclosureCodes,
  //       // deviceId,
  //     ],
  //   },
  // ],
};

export const QuestionFieldsets: FormOptions = {
  primaryFieldsets: [
    ProductOptionsFieldset,
    {
      legend: 'Question Options',
      Icon: QuestionIcon,
      fields: [
        setReadonlyUgcType('Question'),
        createUgcId('Question'),
        siteStatus,
        questionIncludesAnswer,
        questionHasVisualAnswers,
        // questionType,
        // answerStatus,
        // statusIncluded,
        // statusExcluded,
        codesIncluded,
        codesExcluded,
        catalog,
        merchantUserEmail,
        deviceId,
      ],
    },
  ],
  // extraFieldsets: [
  //   {
  //     fields: [
  //       // questionKeyword,
  //       // contentDisclosureCodes,
  //     ],
  //   },
  // ],
};

export const NetworkQuestionFieldsets: FormOptions = {
  primaryFieldsets: [
    {
      ...ProductOptionsFieldset,
      fields: [
        {
          name: 'page_id',
          label: 'Page ID',
          type: 'text',
          style: { flexBasis: '100%' },
          attributes: { required: true },
        },
      ],
    },
    {
      legend: 'Question Options',
      Icon: QuestionIcon,
      fields: [
        setReadonlyUgcType('Question'),
        createUgcId('Question'),
        codesIncluded,
        codesExcluded,
        siteStatus,
      ],
    },
  ],
};

export const AnswerFieldsets: FormOptions = {
  primaryFieldsets: [
    ProductOptionsFieldset,
    {
      legend: 'Answer Options',
      Icon: AnswerIcon,
      fields: [
        setReadonlyUgcType('Answer'),
        createUgcId('Answer'),
        // answerType,
        // statusIncluded,
        // statusExcluded,
        codesIncluded,
        codesExcluded,
        siteStatus,
        catalog,
        merchantUserEmail,
        deviceId,
      ],
    },
  ],
  // extraFieldsets: [
  //   {
  //     fields: [
  //       // questionKeyword,
  //       merchantUserEmail,
  //       // contentDisclosureCodes,
  //       deviceId,
  //     ],
  //   },
  // ],
};



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/config/forms.config.js